import type { CountKey } from '@/pages/events/hooks/useEventsQuery'
import { EVENT_TYPES } from '@/services/api/schemas/events'
import type { EventTypeFilter } from '@/services/events/EventsContext'
import { EVENT_TYPE_COLOR_VAR, EVENT_TYPE_LABELS } from '@/shared/lib/eventTypes'
import { Chip } from '@/shared/ui'

import s from './EventFilters.module.css'

interface EventFiltersProps {
  value: EventTypeFilter
  onChange: (value: EventTypeFilter) => void
  /**
   * Количество событий за выбранный период по типам и всего («all» — с сервера, включает
   * типы, которых интерфейс не знает); undefined — ещё не загружено.
   */
  counts: Partial<Record<CountKey, number>>
}

export function EventFilters({ value, onChange, counts }: EventFiltersProps) {
  return (
    <div className={s.chips} role="group" aria-label="Тип события">
      <Chip active={value === 'all'} onClick={() => onChange('all')} count={counts.all}>
        Все
      </Chip>
      {EVENT_TYPES.map((type) => (
        <Chip
          key={type}
          active={value === type}
          onClick={() => onChange(type)}
          color={EVENT_TYPE_COLOR_VAR[type]}
          count={counts[type]}
        >
          {EVENT_TYPE_LABELS[type]}
        </Chip>
      ))}
    </div>
  )
}
